import { render } from "./ProductCard.vue?vue&type=template&id=cc08077e&ts=true&lang=pug"
import script from "./ProductCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCard.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__